var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIdea = function SvgIdea(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B4CFFF",
    d: "M29.013 59.98c-.599 0-1.108-.234-1.519-.716s-.609-1.068-.609-1.784.2-1.302.61-1.784.908-.716 1.518-.716h12.744c.599 0 1.108.234 1.519.716s.609 1.068.609 1.784-.2 1.302-.61 1.784-.908.716-1.518.716z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F68D1",
    d: "M26.89 52.98a16.5 16.5 0 0 1-5.845-5.893c-1.436-2.46-2.16-5.143-2.16-8.04 0-4.46 1.559-8.262 4.665-11.382 3.118-3.13 6.892-4.685 11.335-4.685s8.228 1.565 11.335 4.685c3.117 3.13 4.665 6.921 4.665 11.383 0 2.896-.724 5.568-2.16 8.04a16.35 16.35 0 0 1-5.846 5.892H26.87z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C9BF1",
    d: "M35.39 65.98c-1.231 0-2.299-.396-3.179-1.177s-1.326-1.719-1.326-2.823h9c0 1.094-.446 2.042-1.326 2.823s-1.936 1.177-3.18 1.177z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D43",
    d: "M33.385 15.98v-11a1.5 1.5 0 0 1 3 0v11a1.5 1.5 0 0 1-3 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD2A8",
    d: "M16.925 12.828a1.5 1.5 0 0 1 2.112.192l5 6a1.5 1.5 0 0 1-2.304 1.92l-5-6a1.5 1.5 0 0 1 .192-2.112"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D43",
    d: "M2.492 25.423a1.5 1.5 0 0 1 1.95-.836l10 4a1.5 1.5 0 0 1-1.114 2.786l-10-4a1.5 1.5 0 0 1-.836-1.95"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD2A8",
    d: "M12.673 42.495a1.501 1.501 0 0 1 .424 2.97l-7 1a1.5 1.5 0 0 1-.424-2.97zM50.637 13.148a1.5 1.5 0 1 1 2.496 1.664l-4 6a1.5 1.5 0 1 1-2.496-1.664z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D43",
    d: "M66.372 24.57a1.501 1.501 0 0 1 1.026 2.82l-11 4a1.5 1.5 0 0 1-1.026-2.82z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD2A8",
    d: "m57.072 42.492 8 1a1.5 1.5 0 0 1-.374 2.976l-8-1a1.5 1.5 0 0 1 .374-2.976"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M42.42 31.57a10.5 10.5 0 0 1 3.014 8.605M37.218 28.737q.518.113 1.023.276"
  })));
};
export default SvgIdea;